import { Switch } from "@/components/ui/switch";
import { UsageBadge } from "@/components/UsageBadge";
import { Layers } from "lucide-react";

const SlotPill = ({ fd, slot }) => {
  const visible = fd.effective("slot", slot.key, "is_visible", true);
  const dirty = fd.isDirty("slot", slot.key);
  const essential = !!slot.essential;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs ${dirty ? "bg-amber-100 ring-1 ring-amber-300" : "bg-slate-100"} ${visible ? "" : "opacity-60 line-through"}`}
          data-testid={`fd-slot-pill-${slot.key}`}
          title={essential ? "Essential — cannot be hidden" : (slot.label || slot.key)}>
      <span>{slot.label || slot.key}</span>
      <Switch checked={!!visible}
              disabled={essential}
              onCheckedChange={(v) => fd.setDraftValue("slot", slot.key, "is_visible", v)}
              data-testid={`fd-slot-visible-${slot.key}`}
              className="scale-75 -my-1" />
      <UsageBadge scope="slot" itemKey={slot.key} />
    </span>
  );
};

export const SlotPills = ({ fd, tabKey, slots }) => {
  if (!slots.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 mb-2 pb-2 border-b border-slate-100"
         data-testid={`fd-slots-${tabKey}`}>
      <span className="text-[11px] uppercase tracking-wider text-slate-500 inline-flex items-center gap-1">
        <Layers className="h-3 w-3" /> Slots:
      </span>
      {slots.map((s) => <SlotPill key={s.key} fd={fd} slot={s} />)}
    </div>
  );
};
